export default "<form>\n  <ng-content></ng-content>\n</form>\n"